import React from 'react';
import { FiX } from 'react-icons/fi';
import { Container, Content } from './styles';
import Button from '../../../../components/Button';
import BannerMotiva from '../../../../assets/Banner/popupdosite_Prancheta1.png';

interface ModalInterface {
  handleClose(): void;
  show: boolean;
  text?: string;
  success?: boolean;
}

const ModalMotiva: React.FC<ModalInterface> = ({ handleClose, show }) => (
  <Container show={show}>
    <section>
      <>
        <button type="button" className="close-container" onClick={handleClose}>
          <FiX size={25} onClick={handleClose} />
        </button>
        <div className="modal-body">
          <Content>
            <a
              href="https://drive.google.com/file/d/1g94XQ94XW79q62rG3_TLZF0xannMjGeS/view"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={BannerMotiva} alt="Banner Motiva" />
            </a>
          </Content>
        </div>
      </>
    </section>
  </Container>
);

export default ModalMotiva;
